import { render, staticRenderFns } from "./ProductSelectBiddingBody.vue?vue&type=template&id=24c4a551&scoped=true"
import script from "./ProductSelectBiddingBody.vue?vue&type=script&lang=js"
export * from "./ProductSelectBiddingBody.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectBiddingBody.vue?vue&type=style&index=0&id=24c4a551&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c4a551",
  null
  
)

export default component.exports